import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import SideFloatingActionBar from '../../common/SideFloatingActionBar';
import WhatsAppChatButton from '../../common/WhatsAppChatButton';
import CategorySidebar from '../Header/CategorySidebar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="dark-theme flex min-h-screen flex-col bg-[#0f0f0f] text-slate-100">
      
      <div data-site-header-shell className="sticky top-0 z-50 w-full shadow-lg">
        <Header />
      </div>
      <div className="mx-auto grid w-full max-w-[1800px] flex-1 grid-cols-1 px-3 min-[375px]:px-4 sm:px-5 lg:px-8 xl:grid-cols-[320px_minmax(0,1fr)] xl:gap-7 2xl:grid-cols-[340px_minmax(0,1fr)] 2xl:gap-8">
      
        <aside className="relative z-40 hidden min-h-full self-stretch border-r border-white/5 bg-[#0f0f0f] xl:block">
          
          <div className="sticky top-[120px] self-start py-4">
            <CategorySidebar />
          </div>
        </aside>

        <main className="min-w-0 flex-1 pb-16 pt-4">
          {children}
        </main>
      </div>

      <Footer />
      <SideFloatingActionBar zIndex={1200} />
      <WhatsAppChatButton phoneNumber="94773421388" zIndex={1200} />
    </div>
  );
};

export default MainLayout;
